import { z } from "zod";
export const MediaFileType = {
    VIDEO_MP4: "video/mp4",
    IMAGE_PNG: "image/png",
    IMAGE_JPEG: "image/jpeg",
    IMAGE_SVG: "image/svg+xml",
    IMAGE_WEBP: "image/webp",
    IMAGE_GIF: "image/gif",
};
export const MediaFileSchema = z.object({
    id: z.string(),
    name: z.string().optional(),
    type: z.nativeEnum(MediaFileType),
    size: z.number().optional(),
    keyS3: z.string(),
    url: z.string().url(),
});
export const S3PolicyInputSchema = z.object({
    key: z.string(),
    route: z.string(),
    contentType: z.string(),
});
export const S3PolicyFieldsSchema = z.object({
    ContentType: z.string(),
    Policy: z.string(),
    XAmzAlgorithm: z.string(),
    XAmzCredential: z.string(),
    XAmzDate: z.string(),
    XAmzSignature: z.string(),
    bucket: z.string(),
    key: z.string(),
});
export const S3PolicySchema = z.object({
    fields: S3PolicyFieldsSchema,
    url: z.string(),
});
export const S3UploadResultSchema = z.object({
    keyS3: z.string(),
    url: z.string(),
});
export const BrowserFileSchema = z.object({
    name: z.string(),
    type: z.string(),
    size: z.number(),
    file: z.instanceof(File),
});
